export const typeStatement = [
    { value: 'COMUNICADO LOCAL' },
    { value: 'JURIDICA' },
    { value: 'BOLETIN DE DDHH' },
    { value: 'LUGAR DE DENUNCIA' },
    { value: 'COMUNICADO ZONAL' },
    { value: 'COMUNICADO NACIONAL' },
    { value: 'SOS' },
    { value: 'MBU' },
    { value: 'BOLETIN ACIN' },
    { value: 'CONOCIMIENTO AUTORIDADES' },
    { value: 'CONOCIMIENTO FISCALIA' },
]
